module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "form",
    attrs: {
      "model": _vm.curInput,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "仅允许一个人员"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.people.select_type),
      expression: "curInput.people.select_type"
    }],
    domProps: {
      "value": (_vm.curInput.people.select_type)
    },
    on: {
      "input": function($event) {
        _vm.curInput.people.select_type = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 10
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 20
    }
  }, [_vm._v("否")])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择范围"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.people.select_range),
      expression: "curInput.people.select_range"
    }],
    domProps: {
      "value": (_vm.curInput.people.select_range)
    },
    on: {
      "input": function($event) {
        _vm.curInput.people.select_range = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 10
    }
  }, [_vm._v("不限")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 20,
      "disabled": ""
    }
  }, [_vm._v("用户所属部门人员")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 30,
      "disabled": ""
    }
  }, [_vm._v("用户下级")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 40
    }
  }, [_vm._v("自定义")])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "已选人员"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.unlimit),
      expression: "unlimit"
    }]
  }, [_vm._v("不限")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rangeCustom),
      expression: "rangeCustom"
    }]
  }, _vm._l((_vm.selectedPeople), function(people) {
    return _c('el-tag', {
      staticClass: "m-l-5",
      attrs: {
        "close-transition": true,
        "closable": true,
        "type": "primary"
      },
      on: {
        "close": function($event) {
          _vm.handleCloseRange(people)
        }
      }
    }, [_vm._v("\n          " + _vm._s(people.realname) + "\n        ")])
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "默认选中值"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.people.select_default),
      expression: "curInput.people.select_default"
    }],
    domProps: {
      "value": (_vm.curInput.people.select_default)
    },
    on: {
      "input": function($event) {
        _vm.curInput.people.select_default = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("无")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("用户")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3,
      "disabled": ""
    }
  }, [_vm._v("用户上级")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 4
    }
  }, [_vm._v("自定义")])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "已选默认人员"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nothing),
      expression: "nothing"
    }]
  }, [_vm._v("无")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user),
      expression: "user"
    }]
  }, [_vm._v("用户")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.superior),
      expression: "superior"
    }]
  }, [_vm._v("用户上级")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.defaultCustom),
      expression: "defaultCustom"
    }]
  }, _vm._l((_vm.selectedDefault), function(defaulter) {
    return _c('el-tag', {
      staticClass: "m-l-5",
      attrs: {
        "close-transition": true,
        "closable": true,
        "type": "primary"
      },
      on: {
        "close": function($event) {
          _vm.handleCloseDefault(defaulter)
        }
      }
    }, [_vm._v("\n          " + _vm._s(defaulter.realname) + "\n        ")])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.singleSelect),
      expression: "singleSelect"
    }]
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.singleDefault),
      expression: "singleDefault"
    }],
    attrs: {
      "placeholder": "请选择"
    },
    domProps: {
      "value": (_vm.singleDefault)
    },
    on: {
      "change": _vm.getDefaultSelection,
      "input": function($event) {
        _vm.singleDefault = $event
      }
    }
  }, _vm._l((_vm.selectedPeople), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.realname,
        "value": item.user_id
      }
    })
  }))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.multiSelect),
      expression: "multiSelect"
    }]
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.multiDefault),
      expression: "multiDefault"
    }],
    attrs: {
      "multiple": "",
      "placeholder": "请选择"
    },
    domProps: {
      "value": (_vm.multiDefault)
    },
    on: {
      "change": _vm.getMultiDefaultSelection,
      "input": function($event) {
        _vm.multiDefault = $event
      }
    }
  }, _vm._l((_vm.selectedPeople), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.realname,
        "value": item.user_id
      }
    })
  }))])]), _vm._v(" ")]), _vm._v(" "), _c('range-select', {
    attrs: {
      "dialogShow": _vm.rangeDialog,
      "title": _vm.rangeTitle,
      "selectedIds": _vm.selectedRangeIds,
      "selectedPeople": _vm.selectedPeople,
      "structData": _vm.structs
    },
    on: {
      "closeDialog": _vm.closeRangeDialog
    }
  }), _vm._v(" "), _c('default-select', {
    attrs: {
      "dialogShow": _vm.defaultDialog,
      "title": _vm.defaultTitle,
      "selectedIds": _vm.selectedDefaultIds,
      "isOnly": _vm.curInput.people.select_type,
      "selectedPeople": _vm.selectedDefault,
      "structData": _vm.structs
    },
    on: {
      "closeDialog": _vm.closeDefaultDialog,
      "beforeSingleChange": _vm.clearData
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d733a662!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Model/configComponents/peopleConfig.vue
// module id = 1994
// module chunks = 2